import React from "react";
import { Alert, Avatar, Col, Icon, Row, Tag, Tooltip } from "antd";
import { Link } from "react-router-dom";
import unescape from "lodash/unescape";
import moment from "moment";

const API_URL = process.env.REACT_APP_API_URL;

export default ({ order, actions, storeId }) => {
  return (
    <Row>
      <Col span={12}>
        <h4>
          <a
            title="View Order on Etsy"
            target="_blank"
            href={`https://www.etsy.com/your/orders/sold?&order_id=${
              order.receipt_id
            }`}
          >
            #{order.receipt_id}
          </a>{" "}
          - {order.name}
        </h4>
        {order.transactions.map((i) => {
          return (
            <div key={i.transaction_id} className="tnx">
              <Avatar
                size={85}
                src={`${API_URL}api/etsy/stores/${storeId}/${i.listing_id}/${i.listing_image_id}`}
                shape="square"
              />
              <div className="details">
                <p>
                  <strong>{i.title}</strong>{" "}
                  {i.mapping ? (
                    i.mapping.ignore ? (
                      <Tooltip title="Product ignored">
                        <Icon type="close-circle" />
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={`Mapping: ${i.mapping.images.length} files, ${
                          i.mapping.catalogName
                        } - ${i.mapping.product_size} - ${
                          i.mapping.quantity
                        } each`}
                      >
                        <Icon type="check-circle" style={{ color: "green" }} />
                      </Tooltip>
                    )
                  ) : (
                    i.canfulfil && (
                      <Tooltip title="Create Mapping on Listings page, shows all variations">
                        <Link
                          to={`/listings/${i.listing_id}?productId=${
                            i.product_id
                          }`}
                        >
                          <Icon type="edit" />
                        </Link>
                      </Tooltip>
                    )
                  )}
                  {i.is_digital && <Tag color="">Digital delivery</Tag>}
                </p>
                <div>
                  {i.variations.map((v) => (
                    <div>
                      <strong>{v.formatted_name}:</strong>{" "}
                      <span>{v.formatted_value}</span>
                    </div>
                  ))}
                </div>
                <div>
                  <strong>Quantity:</strong> <span>{i.quantity}</span>
                </div>
                { i.shipping_upgrade && (
                  <div>
                    <strong>Shipping upgrade:</strong> <span>{i.shipping_upgrade}</span>
                  </div>
                )}
                {!i.canfulfil && <em>Can't be fulfilled</em>}
              </div>
            </div>
          );
        })}
      </Col>
      <Col span={6}>
        <p>
          <strong>
            Ordered{" "}
            <Tooltip
              title={moment
                .unix(order.create_timestamp)
                .format("MMM DD, YYYY h:mmA")}
            >
              {moment.unix(order.create_timestamp).fromNow()}
            </Tooltip>
          </strong>
        </p>
        <div>Total shipping cost {order.total_shipping_cost.amount/order.total_shipping_cost.divisor} {order.total_shipping_cost.currency_code}</div>
        <p>
          {order.city}, {order.state} {order.country_iso}
        </p>
        {order.message_from_buyer && (
          <Alert
            showIcon
            icon={<Icon type="user" />}
            message={unescape(order.message_from_buyer)}
            type="warning"
          />
        )}
        {order.needs_gift_wrap && (
          <Tooltip title="Needs gift wrap">
            <Icon type="gift" theme="twoTone" style={{ fontSize: 24 }} />
          </Tooltip>
        )}
      </Col>
      <Col span={6} className="text-right">
        {actions}
      </Col>
    </Row>
  );
};
